"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOf = exports.select = exports.ANONYMOUS_SELECT_KEY = exports.not = exports.when = void 0;
const symbols = require("./symbols");
const when = (predicate) => ({
    [symbols.PatternKind]: symbols.Guard,
    [symbols.Guard]: predicate,
});
exports.when = when;
const not = (pattern) => ({
    [symbols.PatternKind]: symbols.Not,
    [symbols.Not]: pattern,
});
exports.not = not;
exports.ANONYMOUS_SELECT_KEY = '@ts-pattern/__anonymous-select-key';
function select(key) {
    return key === undefined
        ? {
            [symbols.PatternKind]: symbols.AnonymousSelect,
        }
        : {
            [symbols.PatternKind]: symbols.NamedSelect,
            [symbols.NamedSelect]: key,
        };
}
exports.select = select;
function isInstanceOf(classConstructor) {
    return (val) => val instanceof classConstructor;
}
const instanceOf = (classConstructor) => (0, exports.when)(isInstanceOf(classConstructor));
exports.instanceOf = instanceOf;
